module.exports = __webpack_public_path__ + "img/Calendar.fe6be0ba.svg";